import { Component, model, output, ChangeDetectionStrategy } from '@angular/core';
import { Step } from './models/step';


@Component({
  selector: 'app-onboarding-stepper',
  standalone: true,
  imports: [],
  templateUrl: './onboarding-stepper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './onboarding-stepper.component.scss'
})
export class OnboardingStepperComponent {
  steps = model<Step[]>([]);
  currentStepId = model.required<string>();
  stepChanged = output<string>();

  isStepActive(step: Step) { return step.id === this.currentStepId(); }
  
  showStep(step: Step) {
    this.currentStepId.set(step.id);
    this.stepChanged.emit(step.id);
  }

  getStepOuterRingClass(step: Step): string {
    let classes = '';
    if (this.hasError(step)) {
      classes += ' status-error';
    }
    else if (this.hasWarning(step)) {
      classes += ' status-warning';
    }

    if (step.isCompleted) {
      classes += ' status-completed';
    }

    if (this.isStepActive(step)) {
      classes += ' active';
    }

    return classes;
  }

  hasError(step: Step): boolean {
    return !!step.errorText;
  }

  hasWarning(step: Step): boolean {
    return !this.hasError(step) && !!step.warningText;
  }

}
